module.exports = __webpack_public_path__ + "static/media/union-pay.ff51ce7d.png";